import { Observable, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { AuthorizedEntityDTO, CreateAuthorizedEntityDTO, UpdateAuthorizedEntityDTO } from '../models/authorized-entity.model';
import { GroupTypeEnum } from '@app/features/groups/models/group.model';
import { LinkAccountDTO } from '../models/link-account.model';
import { CreateAuthorizedPersonDTO } from '../models/authorized-person.model';

@Injectable({
  providedIn: 'root'
})
export class AuthorizedEntityService {
  private readonly http = inject(HttpClient);
  private readonly PATH = 'api/authorized';

  readonly authorizedEntityResource = httpResource<AuthorizedEntityDTO[]>(() => `api/authorized/list`);


  getAuthorizedEntity(uuid: string): Observable<AuthorizedEntityDTO> {
    return this.http.get<AuthorizedEntityDTO>(`${this.PATH}/${uuid}`);
  }
  getAuthorizedEntityList(): Observable<AuthorizedEntityDTO[]> {
    return this.http.get<AuthorizedEntityDTO[]>(this.PATH);
  }

  addAuthorizedEntity(authorizedEntity: CreateAuthorizedEntityDTO): Observable<any> {
    return this.http.post(this.PATH, authorizedEntity);
  }

  updateAuthorizedEntity(authorizedEntity: UpdateAuthorizedEntityDTO, uuid: string): Observable<any> {
    return this.http.put(`${this.PATH}/${uuid}`, authorizedEntity);
  }

  getLinkUsers(): Observable<LinkAccountDTO[]> {
    const mockData: LinkAccountDTO[] =
      [
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-001",
          "username": "jkowalski",
          "firstName": "Jan",
          "lastName": "Kowalski",
          "organization": "PKO BP",
          "responsibleUnit": "IT Security",
          "group": GroupTypeEnum.CIVIL,
          "role": "Administrator"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-002",
          "username": "anowak",
          "firstName": "Anna",
          "lastName": "Nowak",
          "organization": "PZU",
          "responsibleUnit": "Operations",
          "group": GroupTypeEnum.CIVIL,
          "role": "Operator"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-003",
          "username": "mwisniewski",
          "firstName": "Marek",
          "lastName": "Wiśniewski",
          "organization": "Orange Polska",
          "responsibleUnit": "Network Services",
          "group": GroupTypeEnum.CIVIL,
          "role": "Team Lead"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-004",
          "username": "kzielinska",
          "firstName": "Katarzyna",
          "lastName": "Zielińska",
          "organization": "Allegro",
          "responsibleUnit": "Customer Support",
          "group": GroupTypeEnum.MILITARY,
          "role": "Specialist"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-005",
          "username": "ppiotrowski",
          "firstName": "Piotr",
          "lastName": "Piotrowski",
          "organization": "Santander",
          "responsibleUnit": "Compliance",
          "group": GroupTypeEnum.MILITARY,
          "role": "Auditor"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-006",
          "username": "ewojcik",
          "firstName": "Ewa",
          "lastName": "Wójcik",
          "organization": "mBank",
          "responsibleUnit": "Risk Management",
          "group": GroupTypeEnum.MILITARY,
          "role": "Manager"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-007",
          "username": "rlewandowski",
          "firstName": "Robert",
          "lastName": "Lewandowski",
          "organization": "ING",
          "responsibleUnit": "Data Analytics",
          "group": GroupTypeEnum.MILITARY,
          "role": "Analyst"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-008",
          "username": "madamczyk",
          "firstName": "Magdalena",
          "lastName": "Adamczyk",
          "organization": "Żabka",
          "responsibleUnit": "Retail Systems",
          "group": GroupTypeEnum.TECH,
          "role": "System Administrator"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-009",
          "username": "tgrabowski",
          "firstName": "Tomasz",
          "lastName": "Grabowski",
          "organization": "LPP",
          "responsibleUnit": "Infrastructure",
          "group": GroupTypeEnum.FMP,
          "role": "Engineer"
        },
        {
          "id": "1f4a6f1b-7c4a-4c12-8b7e-010",
          "username": "jdabrowska",
          "firstName": "Joanna",
          "lastName": "Dąbrowska",
          "organization": "Asseco",
          "responsibleUnit": "Software Development",
          "group": GroupTypeEnum.FMP,
          "role": "Product Owner"
        }
      ]

    return of(mockData);
  }

  deleteAuthorizedEntity(id: string): Observable<any> {
    return this.http.delete(`${this.PATH}/${id}`);
  }

  addAuthorizedPerson(authorizedPerson: CreateAuthorizedPersonDTO, authorizedEntityUuid: string): Observable<any> {
    return this.http.post(`${this.PATH}/${authorizedEntityUuid}/persons`, authorizedPerson);
  }

  refreshAuthorizedEntity(): void {
    this.authorizedEntityResource.reload();
  }

}
